export interface CoinpaymentCurrency {
  value: string;
  label: string;
}

/**
 * The only CoinPayments currencies exposed by the frontend.
 *
 * Keep this list aligned with the v2 currency identifiers available to the
 * account. Backend legacy aliases (for example BNB -> BNB.BSC) are handled by
 * the API client and are intentionally not duplicated in the UI.
 */
export const COINPAYMENTS_V2_CURRENCIES: CoinpaymentCurrency[] = [
  { value: 'BTC', label: 'BTC' },
  { value: 'LTC', label: 'LTC' },
  { value: 'ETH', label: 'ETH' },
  { value: 'BCH', label: 'BCH' },
  { value: 'DOGE', label: 'DOGE' },
  { value: 'DASH', label: 'DASH' },
  { value: 'TRX', label: 'TRX' },
  { value: 'BNB', label: 'BNB' },
  { value: 'XRP', label: 'XRP' },
  { value: 'ETH.BASE', label: 'ETH.BASE' },
  { value: 'POL', label: 'POL' },
  { value: 'SOL', label: 'SOL' },
  { value: 'ETH.ARB', label: 'ETH.ARB' },
  { value: 'EVERY.BASE', label: 'EVERY.BASE' },
  { value: 'USDT.SOL', label: 'USDT.SOL' },
  { value: 'TON.ERC20', label: 'TON.ERC20' },
  { value: 'USDC.SOL', label: 'USDC.SOL' },
  { value: 'USDC.BEP20', label: 'USDC.BEP20' },
  { value: 'SHIB.ERC20', label: 'SHIB.ERC20' },
  { value: 'USDC.BASE', label: 'USDC.BASE' },
  { value: 'USDT.ERC20', label: 'USDT.ERC20' },
  { value: 'USDC.ARB', label: 'USDC.ARB' },
  { value: 'USDT.POL', label: 'USDT.POL' },
  { value: 'EVERY.ERC20', label: 'EVERY.ERC20' },
  { value: 'USDT.ARB', label: 'USDT.ARB' },
  { value: 'TUSD.ERC20', label: 'TUSD.ERC20' },
  { value: 'WETH.BASE', label: 'WETH.BASE' },
  { value: 'ETH.BEP20', label: 'ETH.BEP20' },
  { value: 'WETH.BEP20', label: 'WETH.BEP20' },
  { value: 'BTC.BEP20', label: 'BTC.BEP20' },
  { value: 'SHFL.ERC20', label: 'SHFL.ERC20' },
  { value: 'SHIB.POL', label: 'SHIB.POL' },
  { value: 'USDC.POL', label: 'USDC.POL' },
  { value: 'WETH.POL', label: 'WETH.POL' },
  { value: 'TUSD.TRC20', label: 'TUSD.TRC20' },
  { value: 'AVAX.BEP20', label: 'AVAX.BEP20' },
  { value: 'WETH.ERC20', label: 'WETH.ERC20' },
  { value: 'USDT.BEP20', label: 'USDT.BEP20' },
  { value: 'TON.BEP20', label: 'TON.BEP20' },
  { value: 'USDC.ERC20', label: 'USDC.ERC20' },
  { value: 'USDT.TRC20', label: 'USDT.TRC20' },
  { value: 'DAI.ERC20', label: 'DAI.ERC20' },
];

// Legacy v1-only entries intentionally remain documented here and are not
// exposed by any selector:
// USDT, USDC, DOGE.BEP20, SHIB, SHIB.BEP20, DAI, XMR, PYUSD.ERC20, PAXG,
// LINK, DOT.BEP20, QTUM, RVN.

export const COINPAYMENTS_V2_CURRENCY_VALUES = COINPAYMENTS_V2_CURRENCIES.map(({ value }) => value);

export const COINPAYMENTS_V2_CURRENCY_IMAGES: Record<string, string> = {
  BTC: 'https://static.wixstatic.com/media/8c5863_60142700e27647239fc3c4d628e683cd~mv2.png',
  ETH: 'https://static.wixstatic.com/media/8c5863_0e274522e44749b4b8bdb62cf4001d89~mv2.png',
  USDT: 'https://static.wixstatic.com/media/8c5863_9dfdf2faca044a42ba51b35e8c0cf981~mv2.png',
  USDC: 'https://static.wixstatic.com/media/8c5863_fd7f81d63a004a2db31b348596bceeb3~mv2.png',
  DOGE: 'https://static.wixstatic.com/media/8c5863_a762f086cc734de8b338d277bd5d02c6~mv2.png',
  'DOGE.BEP20': 'https://static.wixstatic.com/media/8c5863_a762f086cc734de8b338d277bd5d02c6~mv2.png',
  XRP: 'https://static.wixstatic.com/media/8c5863_10d4c90169bc48d9b84c748745bd8294~mv2.png',
  BNB: 'https://static.wixstatic.com/media/8c5863_e428a0f873e044acbcabfddfed4eed43~mv2.png',
  'BNB.BSC': 'https://static.wixstatic.com/media/8c5863_e428a0f873e044acbcabfddfed4eed43~mv2.png',
  SOL: 'https://static.wixstatic.com/media/8c5863_4fe0ad91599142ca8633c2fbfe9313a0~mv2.png',
  TRX: 'https://static.wixstatic.com/media/8c5863_29bf6320d0e144c5adf7be160b396143~mv2.png',
  SHIB: 'https://static.wixstatic.com/media/8c5863_9bdc6dbe35654865aadaf04739eb3fcf~mv2.png',
  'SHIB.BEP20': 'https://static.wixstatic.com/media/8c5863_9bdc6dbe35654865aadaf04739eb3fcf~mv2.png',
  'SHIB.ERC20': 'https://static.wixstatic.com/media/8c5863_9bdc6dbe35654865aadaf04739eb3fcf~mv2.png',
  BCH: 'https://static.wixstatic.com/media/8c5863_d2551672601041e199f2995a540584a8~mv2.png',
  DAI: 'https://static.wixstatic.com/media/8c5863_01af583c31b74c4a80e1174894ef4174~mv2.png',
  'DAI.ERC20': 'https://static.wixstatic.com/media/8c5863_01af583c31b74c4a80e1174894ef4174~mv2.png',
  POL: 'https://static.wixstatic.com/media/8c5863_b18f2adfc4f4442ba7548f8eb2919723~mv2.png',
  DASH: 'https://static.wixstatic.com/media/8c5863_c727a5ce0c644dbf880e231bd7372035~mv2.png',
  XMR: 'https://static.wixstatic.com/media/8c5863_be3279a0e9e5405180e86529b7e57e1b~mv2.png',
  PYUSD: 'https://static.wixstatic.com/media/8c5863_ea998b27b043407e8a351e2832304223~mv2.png',
  'PYUSD.ERC20': 'https://static.wixstatic.com/media/8c5863_ea998b27b043407e8a351e2832304223~mv2.png',
  PAXG: 'https://static.wixstatic.com/media/8c5863_16b61b57a1fb4a62bfada5255412ca72~mv2.png',
  LINK: 'https://static.wixstatic.com/media/8c5863_e62833bfe95f4adca7a3ba0392730651~mv2.png',
  DOT: 'https://static.wixstatic.com/media/8c5863_7a185c37566d4cf8b56f31ad31435977~mv2.png',
  'DOT.BEP20': 'https://static.wixstatic.com/media/8c5863_7a185c37566d4cf8b56f31ad31435977~mv2.png',
  QTUM: 'https://static.wixstatic.com/media/8c5863_3c8e37c9fbcc4a00bd1475ac1755a6d5~mv2.png',
  RVN: 'https://static.wixstatic.com/media/8c5863_5fdcfa43e0054c0ebfa38b22160374d3~mv2.png',
};
